export default {
	welcome: "Bem-vindo ao ORI",
	subtitle: "Sistema de Gestão para Templos de Umbanda",
	description: "Uma plataforma completa para gerenciar a vida espiritual do seu templo, desde o acompanhamento da jornada mediúnica até a organização de rituais e correntes.",
	trust: {
		secure: "Seguro e Confiável",
		secureDesc: "Dados protegidos com criptografia",
		respectful: "Respeitoso",
		respectfulDesc: "Desenvolvido com carinho e respeito às tradições",
		intuitive: "Intuitivo",
		intuitiveDesc: "Interface simples e fácil de usar",
	},
	tagline: "Construído de um filho do Axé para outro filho do Axé",
	howItWorks: {
		title: "Como Funciona",
		subtitle: "Em três passos simples, seu templo estará organizado",
		step1: {
			title: "Cadastre seu Templo",
			description: "Crie sua conta, defina o nome do templo e convide os usuários",
		},
		step2: {
			title: "Configure sua Casa",
			description: "Adicione os médiuns, seus guias, seus tipos de atendimentos e rituais",
		},
		step3: {
			title: "Gerencie com Facilidade",
			description: "Controle rituais, atendimentos, financeiro e acompanhe a jornada mediúnica",
		},
	},
	faq: {
		title: "Perguntas Frequentes",
		q1: "Eu posso testar o ORI?",
		a1: "Sim! Oferecemos 30 dias grátis para testar todas as funcionalidades. Após o período de teste, escolha o plano ideal para o seu templo.",
		q2: "Meus dados ficam seguros?",
		a2: "Absolutamente. Usamos criptografia, isolamento por templo (RLS) e backups automáticos. Nenhum templo acessa dados de outro.",
		q3: "Funciona no celular e tablet?",
		a3: "Estamos trabalhando na compatibilidade com celular. Em tablets, o sistema funciona perfeitamente.",
		q4: "Tenho como chamar fichas numa TV?",
		a4: "Sim, o ORI dispõe de um aplicativo Android para Google TV ou Fire TV, onde você pode chamar fichas pelo tablet ou celular, além de exibir mensagens e vídeos personalizados para os consulentes.",
		q5: "Posso usar minhas fichas físicas? Ou ele imprime fichas?",
		a5: "Você pode usar suas fichas físicas, ou, usar a opção de imprimir via impressora térmica. O custo por ticket impresso é inferior a 1 centavo. Além disso, o ticket possui mais informações, podendo incluir mensagens personalizadas para cada consulente.",
		q6: "Posso usar em mais de um templo?",
		a6: "Sim. Uma mesma conta de usuário pode estar vinculada a múltiplos templos com papéis diferentes. Cada templo possui seu próprio plano e assinatura independente.",
		q7: "O ORI tem integração com banco para receber pagamentos?",
		a7: "Sim! Através do Mercado Pago, você conecta a conta do seu templo e passa a cobrar mensalidades e contribuições por PIX ou cartão de crédito — com link de pagamento, baixa automática e débito automático recorrente. As taxas são do próprio Mercado Pago: PIX 0,99% por transação (liberação na hora) e cartão de crédito cerca de 4,98% (caindo para ~3,98% após 30 dias), inclusive nas cobranças recorrentes. O ORI não cobra nada a mais — o dinheiro cai direto na conta do templo.",
	},
	manual: {
		link: "Manual",
	},
	nav: {
		screens: "Telas",
		faq: "FAQ",
		contact: "Contato",
		plans: "Planos",
	},
	contact: {
		title: "Fale Conosco",
		subtitle: "Tem alguma dúvida ou sugestão? Envie sua mensagem!",
		name: "Nome",
		subject: "Assunto",
		message: "Mensagem",
		email: "Email",
		phone: "Celular",
		referralSource: "Como ficou sabendo do ORI?",
		send: "Enviar Mensagem",
		success: "Mensagem enviada com sucesso! Entraremos em contato em breve.",
		errors: {
			message: "Mensagem é obrigatória",
			email: "Email é obrigatório",
			generic: "Erro ao enviar mensagem. Tente novamente.",
		},
		referrals: {
			google: "Google / Busca na internet",
			socialMedia: "Redes sociais",
			friend: "Indicação de amigo",
			event: "Evento / Congresso",
			other: "Outro",
		},
	},
	cta: {
		login: "Fazer Login",
		dashboard: "Ir para Dashboard",
		getStarted: "Iniciar Agora",
		learnMore: "Saiba Mais",
	},
	pricing: {
		noCardRequired: "Não é pedido cartão no período de testes",
	},
	testimonials: {
		title: "Confiança e Organização Espiritual",
		subtitle: "Desenvolvido com respeito e compreensão das tradições umbandistas",
	},
};
